// All relevant files for data definition to be used for the service; i.e. table configuration; initial service data
// or configurations, date formatter, currencies, etc.

export const WINDOW_HEIGHT_BREAKPOINT = 1200; // TODO find appropriate value

export const calcShowBodyBottomBar = (height: number) => height < WINDOW_HEIGHT_BREAKPOINT;
